import React from "react";

import classes from "./ExportLayoutSelect.module.css";

// Lays the export pickers out side by side: video on the left, audio layout
// on the right, labels above their dropdowns. The left column takes the spare
// width, so its dropdown shrinks before anything wraps.
const ExportOptions = ({ children, className = "" }) => (
    <div className={`${classes["ExportOptions"]} ${className}`}>{children}</div>
);

export default ExportOptions;
